import { z } from 'zod'

const NON_COUNT_RE_GLOBAL = /[\s\p{P}\p{S}]/gu

export function countEffectiveChars(text: string): number {
  if (!text) return 0
  return Array.from(text.replace(NON_COUNT_RE_GLOBAL, '')).length
}

export function zStringEffectiveLimit(limit: number) {
  return z.string().superRefine((val, ctx) => {
    const count = countEffectiveChars(val)
    if (count > limit) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `当前有效字符 ${count}，超过限制 ${limit}`,
      })
    }
  })
}
